import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createCameraView,
  deleteCameraView,
  fetchCameraView,
  fetchCameraViews,
  type CreateCameraViewPayload,
  type UpdateCameraViewPayload,
  updateCameraView,
} from '../queries/cameraViews.queries'

export const useCameraViews = () =>
  useQuery({
    queryKey: ['camera-views'],
    queryFn: fetchCameraViews,
  })

export const useCameraView = (id: string | undefined) =>
  useQuery({
    queryKey: ['camera-views', id],
    queryFn: () => fetchCameraView(id!),
    enabled: !!id,
  })

export const useCreateCameraView = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: CreateCameraViewPayload) => createCameraView(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['camera-views'] })
    },
  })
}

export const useUpdateCameraView = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpdateCameraViewPayload) => updateCameraView(payload),
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: ['camera-views'] })
      queryClient.invalidateQueries({ queryKey: ['camera-views', payload.id] })
    },
  })
}

export const useDeleteCameraView = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteCameraView(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['camera-views'] })
      queryClient.invalidateQueries({ queryKey: ['camera-views', id] })
    },
  })
}
